<template>
	<div
		id="attendance-modal"
		class="modal fade"
		tabindex="-1"
		aria-labelledby="attendance-modal"
		@keyup.esc.stop.prevent="CloseModal()"
	>
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<button
					type="button"
					class="absolute btn btn-tool p-3 ps-r-1 ps-t-0 m-3 z-50"
					@click="CloseModal()"
				>
					<i class="far fa-times mx-1"></i>
				</button>

				<div class="modal-body w-full h-full flex flex-col">
					<div
						v-if="origin === 'journey' && attendance?.logs?.length"
						class="w-full flex-1 relative px-3 overflow-y-auto"
					>
						<span class="absolute z-10 ps-b-0 ps-t-0 ps-l-3 border-left bg-dark"></span>
						<div
							v-for="(log, index) in attendance.logs"
							:key="`${log.author}${index}`"
							class="w-full py-4 pl-5 relative z-20"
						>
							<span
								class="dot-log absolute p-2 rounded-circle mt-2"
								:class="{
									'bg-primary': index === 0,
									'bg-secondary': index > 0,
								}"
							></span>
							<div class="w-full md:w-6/12 flex justify-center">
								<span class="w-3/12 text-dark font-14">
									<b>{{ log.status }}</b>
								</span>
								<span class="w-9/12 text-dark">
									{{ log.date_time }}
								</span>
							</div>
							<template v-if="log.logType === 'user'">
								<template v-if="log.description">
									<div class="w-full md:w-6/12 flex justify-center">
										<span class="w-3/12 text-muted font-14"> Descrição </span>
										<span class="w-9/12 text-dark">{{ log.description }}</span>
									</div>
								</template>
								<div class="w-full md:w-6/12 flex justify-center">
									<span class="w-3/12 text-muted font-14"> Autor </span>
									<span class="w-9/12 text-dark">{{ log.author }}</span>
								</div>
								<div class="w-full md:w-6/12 flex justify-center">
									<span class="w-3/12 text-muted font-14"> Procedimento </span>
									<span class="w-9/12 text-dark">{{
										log.proceeding ?? 'Sem procedimento vinculado'
									}}</span>
								</div>
							</template>
							<template v-else>
								<div class="w-full md:w-6/12 flex justify-center">
									<span class="w-3/12 text-muted font-14"> Autor </span>
									<span class="w-9/12 text-dark"> SISTEMA </span>
								</div>
							</template>
						</div>
					</div>

					<scheduling-card
						v-if="origin !== 'journey' && attendance_id"
						ref="scheduling_card"
						class="w-full flex-1 mt-5"
						:attendance_id="attendance_id"
						@update-attendance="attendance = $event"
						@update-payment-info="HandleUpdatePaymentInfo"
					/>
					<div
						class="w-full flex items-center gap-5"
						:class="{
							'justify-content-between': is_scheduling_origin,
							'justify-content-end': !is_scheduling_origin,
						}"
					>
						<button
							v-if="is_scheduling_origin"
							class="btn btn p-3 px-4"
							@click="ShowPaymentMethods"
						>
							PAGAMENTO
						</button>
						<button
							class="btn btn p-3 px-4"
							@click="PrintAttendance"
						>
							IMPRIMIR
							<i class="far fa-print ml-3"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
		<PaymentMethodsModal
			v-if="is_scheduling_origin"
			:total="payment_info.total"
			:payment_methods_props="payment_info"
			@payment-methods-added="UpdatePaymentInfo"
		/>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	const moment = require('moment')

	import SchedulingCard from '@/components/search/SchedulingCard'
	import PaymentMethodsModal from '@/components/shared/payment/PaymentMethodsModal'
	import Swal from 'sweetalert2'

	export default {
		name: 'AttendanceModal',
		components: {
			SchedulingCard,
			PaymentMethodsModal,
		},
		props: {
			attendance_id: {
				type: Number,
				default: null,
			},
			origin: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				ORIGINS: {
					SCHEDULING_PRE_APPOINTMENT: 2,
					SCHEDULING_URGENT_APPOINTMENT: 3,
					FIT: 4,
				},
				payment_info: {
					total: 0,
				},
				scheduling_id: null,
				attendance: null,
				modalElementId: 'attendance-modal',
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			is_scheduling_origin() {
				return (
					this.attendance &&
					[
						this.ORIGINS.SCHEDULING_PRE_APPOINTMENT,
						this.ORIGINS.SCHEDULING_URGENT_APPOINTMENT,
						this.ORIGINS.FIT,
					].indexOf(this.attendance.origin) > -1
				)
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetAttendance() {
				this.StartLoading()

				return window.api
					.call('post', '/get-attendances', {
						account_id: this.requester_selected_id,
						attendance_id: this.attendance_id,
					})
					.then(({ data }) => {
						if (data.response) {
							if (data.scheduling) {
								this.attendance = data.scheduling
							}
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Erro!',
								text: 'Houve um erro ao buscar os dados do atendimento, contate o suporte.',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			PrintAttendance() {
				const vm = this

				const fn = event => {
					if (event.data.print) {
						window.removeEventListener('message', fn)

						win.close()
					}
				}

				let query = `attendance_id=${vm.attendance.id}`

				if (vm.origin === 'search' || vm.origin === 'schedulings') {
					query = `journey_id=${vm.attendance.journey_id}`
				}

				const win = window.open(`/pesquisa/imprimir?${query}`, '_blank')
				win.mainWindow = window
				window.addEventListener('message', fn)
			},
			FormatDate(value, fmt) {
				const m = moment(value, 'YYYY-MM-DD HH:mm:ss')

				return m.format(fmt)
			},
			ShowPaymentMethods() {
				window.jQuery('#payment-methods-modal').modal('show')
			},
			HandleUpdatePaymentInfo(payment_info) {
				this.payment_info = payment_info
			},
			UpdatePaymentInfo(payment_info) {
				this.StartLoading()

				return window.api
					.call('post', '/update-payment-info', {
						payment_info,
						journey_id: this.attendance.journey_id,
						scheduling_id: this.attendance.scheduling_id,
					})
					.then(({ data }) => {
						if (data.response) {
							Swal.fire({
								icon: 'success',
								title: 'Informações de pagamento salvas com sucesso.',
								toast: true,
								timer: 3000,
								position: 'top',
								timerProgressBar: true,
							})
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Erro!',
								text: 'Houve um erro ao salvar as informações de pagamento, contate o suporte.',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			Open() {
				const modal = window.jQuery(`#${this.modalElementId}`)
				modal.modal({
					focus: false,
				})
				modal.modal('show')
			},
			CloseModal() {
				window.jQuery(`#${this.modalElementId}`).modal('hide')
				window.jQuery('body').removeClass('modal-open')

				window.jQuery('.modal-backdrop').remove()

				this.$emit('close')
			},
		},
		mounted() {
			window.jQuery(`#${this.modalElementId}`).on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')

				window.jQuery('.modal-backdrop').remove()

				this.$emit('close')
			})

			if (this.origin === 'journey') this.GetAttendance()

			this.Open()
		},
	}
</script>

<style lang="scss" scoped>
	#attendance-modal {
		.modal-dialog {
			max-width: 100vw;
			max-height: 100vh;
			overflow-y: auto;
			margin: 0;

			.modal-content {
				height: 100vh;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 1rem;
			}
		}
	}

	.modal-lg {
		max-width: 850px;
	}

	.dot-log {
		left: -5px;
	}
</style>
